module.exports = __webpack_public_path__ + "img/shutterstock_68730523.2d72c7b9.jpg";